// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"pv-z","expressButtonContainerWithPayPal":"qv-z","expressButton":"rv-z","or":"sv-z"};